import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isSinapsisTestBusiness } from '@core/constants/sinapsis-business.constant';
import { CompanyService } from '@features/company/services/company.service';
import { map } from 'rxjs';

/**
 * @description
 * Controla el acceso a mantenimiento básico/avanzado según
 * `businesses/sitemaps/advance-maintenance`.
 *
 * Usa `data.requiresAdvancedMaintenance`:
 * - `true` → solo si la modalidad avanzada está habilitada
 * - `false` → solo si la modalidad avanzada NO está habilitada
 *
 * El negocio Sinapsis de pruebas siempre tiene acceso a ambas modalidades.
 */
export const advanceMaintenanceModalityGuard: CanActivateFn = (route) => {
  const companyService = inject(CompanyService);
  const router = inject(Router);
  const requiresAdvanced = route.data['requiresAdvancedMaintenance'] === true;

  if (isSinapsisTestBusiness(companyService.business)) {
    return true;
  }

  const redirectTree = router.parseUrl(
    requiresAdvanced ? '/basic-maintenance' : '/advanced-maintenance',
  );

  const businessId = companyService.business?.id ?? companyService.businessId();
  if (!businessId) {
    return router.parseUrl('/home');
  }

  const apply = (advanced: boolean) => {
    const allowed = requiresAdvanced ? advanced : !advanced;
    return allowed ? true : redirectTree;
  };

  return companyService.ensureAdvanceMaintenanceLoaded(businessId).pipe(
    map((config) => apply(config?.advanceMaintenance ?? companyService.advancedMaintenanceEnabled())),
  );
};
